<template>
  <div>
    <a-modal :title="$t('systemBase.pleaseSelectTenant')"
             :width='350'
             :visible='isMultiTenant'
             :closable='false'
             :maskClosable='false'>
      <a-form>
        <a-form-item style='margin-bottom:10px' :validate-status='validate_status1'>
          <a-tooltip placement='topLeft'>
            <template slot='title'>
              <span>您有多个租户，请选择登录租户</span>
            </template>
            <a-avatar style='backgroundColor:#87d068' icon='gold' />
          </a-tooltip>
          <a-select @change='handleTenantChange' :class="{'valid-error':validate_status1=='error'}" :placeholder="$t('systemBase.pleaseSelectTenant')" class='dept-select'>
            <a-icon slot='suffixIcon' type='gold' />
            <a-select-option v-for='d in tenantList' :key='d.id' :value='d.id'>
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <template slot='footer'>
        <a-button type='primary' @click="selectOk('tenant')">{{ $t('button.confirm') }}</a-button>
      </template>
    </a-modal>
    <a-modal :title="$t('tip.pleaseSelectDepartmentFirst')"
             :width='350'
             :visible='isMultiDepart'
             :closable='false'
             :maskClosable='false'>
      <template slot='footer'>
        <a-button type='primary' @click="selectOk('depart')">{{ $t('button.confirm') }}</a-button>
      </template>
      <a-form>
        <a-form-item style='margin-bottom:10px' :validate-status='validate_status2'>
          <a-tooltip placement='topLeft'>
            <template slot='title'>
              <span>您有多个部门，请选择登录部门</span>
            </template>
            <a-avatar style='backgroundColor:rgb(104, 208, 203);' icon='gold' />
          </a-tooltip>
          <a-select @change='handleDepartChange' :class="{'valid-error':validate_status2=='error'}" :placeholder="$t('tip.pleaseSelectDepartmentFirst')" class='dept-select'>
            <a-icon slot='suffixIcon' type='gold' />
            <a-select-option v-for='d in departList' :key='d.orgCode' :value='d.orgCode'>
              {{ d.departName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, putAction } from '@/api/manage'
import { USER_INFO } from '@/store/mutation-types'
import store from './Login'
import { getCompanyListByPermission, tenantUserId } from '@api/api'
import { toast } from '@/utils/util'

export default {
  name: 'LoginSelectTenant',
  data(){
    return {
      visible: false,
      isMultiDepart: false,
      departList: [],

      isMultiTenant: false,
      tenantList: [],

      username: '',
      orgCode: '',
      'tenant-id': '',

      validate_status1: '',
      validate_status2: ''
    }
  },
  methods: {
    clear(){
      this.departList = []
      this.tenantList = []
      this.visible = false
      this.validate_status1 = ''
      this.validate_status2 = ''
    },
    // 登录成功后获取租户
    show( loginResult ){
      this.clear()
      let user = Vue.ls.get(USER_INFO)
      this.username = user.username
      this.bizTenant(loginResult)
    },
    // 获取租户id
    bizTenant( loginResult ){
      let userId = loginResult.userInfo.id
      tenantUserId({ userId }).then(res => {
        this.tenantList = res.result || []
        if (this.tenantList.length === 1) {
          this['tenant-id'] = this.tenantList[ 0 ].id
          // 租户id存到缓存中
          this.$store.dispatch('saveTenant', this.tenantList[ 0 ].id)
          this.bizDepart(loginResult)
        } else {
          this.visible = true
          this.isMultiTenant = true
        }
      })
    },
    bizDepart(loginResult){
        this.departList = loginResult.departs || []
        if (this.departList.length == 0) {
          this.departSelect()
          this.$toast(this.$t('tip.YouDoNotBelongToTheDepartmentPleaseConfirmTheAccountInformation'))
          this.isMultiDepart = false
        } else if (this.departList.length == 1) {
          this.orgCode = this.departList[ 0 ].value
          this.isMultiDepart = false
          this.departSelect()
        } else {
          this.visible = true
          this.isMultiDepart = true
        }
    },
    requestFailed( err ){
      let description = err?.response?.data?.message || err?.message || this.$t('systemBase.systemServiceError')
      this.$toast(description, this.$t('label.loginFailed'))
      this.loginBtn = false
    },
    departSelect(){
      let obj = {
        orgCode: this.orgCode,
        username: this.username
      }
      putAction('/mtc-auth/sys/selectDepart', obj).then(res => {
        if (res.success) {
          const userInfo = res.result.userInfo
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
          this.$store.commit('SET_INFO', userInfo)
          this.isMultiTenant = false
          this.$emit('success')
        } else {
          this.requestFailed(res)
          this.$store.dispatch('Logout')
        }
      })
    },
    selectOk( type ){
      if (type == 'tenant' && !this['tenant-id']) {
        this.validate_status1 = 'error'
        return false
      } else if (type == 'tenant' && this['tenant-id']) {
        this.isMultiTenant = false
        this['tenant-id'] = ''
        this.isMultiDepart = true
        this.bizDepart()
      }
      if (type == 'depart' && !this.orgCode) {
        this.validate_status2 = 'error'
        return false
      } else if (type == 'depart' && this.orgCode) {
        this.departSelect()
      }
    },
    handleTenantChange( e ){
      this.validate_status1 = ''
      this['tenant-id'] = e
      this.$store.dispatch('saveTenant', this['tenant-id'])
    },
    handleDepartChange( e ){
      this.validate_status2 = ''
      this.orgCode = e
    }
  }
}
</script>

<style scoped>
.dept-select {
  position: relative;
  top: 2px;
  margin: 0 0 0 10px;
  width: 86%;
}
</style>